import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ueber',
  templateUrl: './ueber.component.html',
  styleUrls: ['./ueber.component.scss']
})
export class UeberComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
